import { useFeatures } from 'flagged'
import { FeatureFlagsProps } from 'typings/FeatureFlags'

const useFeatureFlags = () => {
  return useFeatures() as unknown as FeatureFlagsProps
}

export default useFeatureFlags
